import { ModuleTypesEnum } from "@/includes/logic/Modules/types";
import FilterModule from "@/includes/logic/Modules/modules/filters/FilterModule";

export default class EmailLinksFilterHandlerModule extends FilterModule {
  type: ModuleTypesEnum = ModuleTypesEnum.EmailLinksFilterHandlerModule;

  params = undefined
}
